import React from "react";

import config from "../config/config";

import CrossIcon from "../svg/cross";
import MinusIcon from "../svg/minus";

const max_tickets_bookable = config.OPTION_FIELDS.max_tickets_bookable
  ? parseInt(config.OPTION_FIELDS.max_tickets_bookable)
  : null;

export default function TicketQuantityButtons(props) {
  return (
    <div className="ticket-quantity-buttons">
      <div
        className="ticket-quantity-buttons__counter"
        role="region"
        aria-live="assertive"
      >
        {props.ticketQuantity}
      </div>
      <button
        className="btn btn--square ticket-quantity-buttons__increment"
        type="button"
        disabled={
          max_tickets_bookable
            ? props.ticketQuantity >= max_tickets_bookable
            : false
        }
        onClick={() => props.setTicketQuantity(props.ticketQuantity + 1)}
      >
        <span className="sr-only">Increase ticket quantity</span>
        <CrossIcon />
      </button>
      <button
        className="btn btn--square ticket-quantity-buttons__decrement"
        type="button"
        disabled={props.ticketQuantity <= 0}
        onClick={() => props.setTicketQuantity(props.ticketQuantity - 1)}
      >
        <span className="sr-only">Decrease ticket quantity</span>
        <MinusIcon />
      </button>
    </div>
  );
}
